/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { Route } from '@angular/router';

export const uiModals: ReadonlyArray<Route> = [
  {
    data: {
      loadModal: () =>
        import('./ui-modal-index').then(
          i => i.allModalComponents.CameraModalComponent,
        ),
    },
    loadChildren: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
    path: 'hack_not_used',
  },
];
